module.exports = __webpack_public_path__ + "static/calm-56a381189df7dfb02b3cb07740914f10.png";